export default "__VITE_ASSET__25a8c0fa__"